import { InputLabel, TextField } from "@mui/material";
import styled from "styled-components";
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Link } from "react-router-dom";

export const Heading = styled.h1`
  text-align: center;
  font-weight: 600;
  color: #000a14;
  font-size: 28px;
  white-space: nowrap;
  @media only screen and (min-width: 796px) {
    font-size: 34px;
  }
  font-size: 28px;
`;

export const OuterHeadingText = styled.h3`
  margin: 0;
  color: #c8cbce;
`;

export const InputTextField = styled(TextField)`
  width: 100%;
  white-space: pre-line;
`;
export const InputLabelText = styled(InputLabel)`
  font-size: 14px;
  font-weight: 500;
  color: #011428;
  margin-top: 1.5rem;
`;

export const KnowPasswordText = styled(Link)`
  cursor: pointer;
  font-weight: 400;
  font-size: 12px;
  color: #023364;
  text-decoration: none;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;
export const RequiredText = styled.sup`
  color: #034a93;
`;

export const ShowPasswordIcon = styled(VisibilityOutlined)`
  color: #034a93;
  font-size: 1.2em !important;
  cursor: pointer;
  position: absolute;
  right: 1rem;
  top: 0.6rem;
  z-index: 2;
`;

export const HidePasswordIcon = styled(VisibilityOffOutlined)`
  color: #034a93;
  font-size: 1.2em !important;
  cursor: pointer;
  position: absolute;
  right: 1rem;
  top: 0.6rem;
  z-index: 2;
`;

export const PasswordDiv = styled.div`
  position: relative;
`;

export const HeaderLogo = styled.img`
  @media only screen and (max-width: 767px) {
    width: 38px;
    height: 26px;
    padding: 0.6rem 0 0 1.2rem;
  }
`;

export const EmailDiv = styled.div`
  position: relative;
`;

export const SubmitButton = styled(LoadingButton)`
  text-transform: none;
  background: #034a93;
  color: white !important;
  font-weight: bold;
  width: 100%;
  height: 3.5rem;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 3rem;
`;

export const SubText = styled.p`
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  white-space: nowrap;
  line-height: 160%;
`;
